export const DEFAULT_YEAR = new Date().getFullYear();

// all australian campuses that have mappings on study site
export const DEFAULT_LOCATION_CODES = [
  '1', // Bentley Perth Campus
  '3', // Kalgoorlie Campus
  '5', // Perth City Campus
  '9', // Geraldton University Centre
  '125', // Curtin OUA
  '134', // Albany Hlth Campus Educ Cntr
];
